export default __webpack_public_path__ + "e7663f1a0597ed26869609d02194f91c.ttf";